import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './routes';
import './index.scss';
import axios from 'axios';
import util from './util.json';

/*--Temas--*/
import '@themes/default.scss'
import '@themes/light.scss'

/* Base url para requisicoes utilizando o Axios */
if (process.env.NODE_ENV !== 'development') {
	axios.defaults.baseURL = util.baseUrl.prod;
} else {
  	axios.defaults.baseURL = util.baseUrl.dev;
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Routes />);
